import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Table,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import CommonService from '../../services/CommonService';
// import global from '../../global';

class ViewChequeModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      chequeid: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]).isRequired,
   };

   static defaultProps = {
      modal: false,
   };

   constructor() {
      super();
      this.state = {
         amount: '0',
         bank: '',
         chequeNumber: '',
         chequeDate: '',
         accountNumber: '',
         accountName: '',
      };
   }

   componentDidMount() {
      const { chequeid } = this.props;
      this.isLoading = true;
      this.onLoadPayments(chequeid);
   }

   componentWillReceiveProps(nextProps) {
      this.isLoading = true;
      this.onLoadPayments(nextProps.chequeid);
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   onLoadPayments = async (chequeid = 0) => {
      try {
         const response = await CommonService.getRows(`chequedetails/paymentid/${chequeid}`);
         if (this.isLoading && response) {
            this.setState({
               amount: response.amount,
               bank: response.bank,
               chequeNumber: response.cheque_number,
               chequeDate: response.cheque_date,
               accountNumber: response.account_number,
               accountName: response.account_name,
            });
         }
      } catch (err) {
         console.log('Error: ', err.message);
      }
      this.isLoading = false;
   }

   render() {
      const {
         modal, toggle,
      } = this.props;
      const {
         amount, bank, chequeNumber, chequeDate, accountNumber, accountName,
      } = this.state;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Cheque Details</h4>
               </div>
               <div className="modal__body p-t-10">
                  <Table>
                     <tbody>
                        <tr>
                           <td><strong>Amount:</strong></td>
                           <td>&#x20b1; {amount}</td>
                        </tr>
                        <tr>
                           <td><strong>Bank:</strong></td>
                           <td>{bank}</td>
                        </tr>
                        <tr>
                           <td><strong>Cheque Number:</strong></td>
                           <td>{chequeNumber}</td>
                        </tr>
                        <tr>
                           <td><strong>Cheque Date:</strong></td>
                           <td>{chequeDate}</td>
                        </tr>
                        <tr>
                           <td><strong>Account Number:</strong></td>
                           <td>{accountNumber}</td>
                        </tr>
                        <tr>
                           <td><strong>Account Name:</strong></td>
                           <td>{accountName}</td>
                        </tr>
                     </tbody>
                  </Table>
               </div>
               <ButtonToolbar className="modal__footer">
                  <Button onClick={toggle}>Close</Button>
               </ButtonToolbar>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'ViewChequeModal', // a unique identifier for this form
})(ViewChequeModal);
